import "./csp-bootstrap";
import Vue from "vue";
import { ToastPlugin, ModalPlugin } from "bootstrap-vue";
import VueCompositionAPI from "@vue/composition-api";
import VueFormulate from "./libs/VueFormulate";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

import i18n from "@/libs/i18n";
import router from "./router";
import store from "./store";
import App from "./App.vue";

// Global Components
import "./global-components";
import localStorageMiddleware from "@/utils/localStorageMiddleware";
Vue.use(localStorageMiddleware);

// 3rd party plugins
import "@axios";
import "@/libs/acl";
import "@/libs/portal-vue";
import "@/libs/clipboard";
import "@/libs/toastification";
import "@/libs/sweet-alerts";
import "@/libs/vue-select";
import "@/libs/postal";

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

// Composition API
Vue.use(VueCompositionAPI);

// Custom directive 'properties' -> <input v-properties="dynamicProperties" />
Vue.directive("properties", {
  bind(el, binding) {
    if (Array.isArray(binding.value)) {
      binding.value.forEach((prop) => {
        if (prop.name && prop.value !== undefined) {
          el.setAttribute(prop.name, prop.value);
        }
      });
    }
  },
});
import Pusher from "pusher-js";
window.Pusher = Pusher;

window.Pusher.logToConsole = true;

// ensure the user private channel is always subscribed
// const subscribeUserPrivateChannel = () => {
//   try {
//     const user = store.getters && store.getters['user/getUser'];
//     if (user && user.id) {
//       store.dispatch('grid/setAlarmsWS');
//     }
//   } catch (e) {
//     // no-op
//   }
// };

import VueKonva from "vue-konva";
import { localize } from "vee-validate";
import Echo from "laravel-echo";
Vue.use(VueKonva);

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require("@core/assets/fonts/feather/iconfont.css"); // For form-wizard

// import core styles
require("@core/scss/core.scss");

// import assets styles
require("@/assets/scss/style.scss");

Vue.config.productionTip = false;

window.abortController = new AbortController();

function initEcho() {
  const host = window.__env?.VUE_APP_LARAVEL_PUSHER_HOST;
  const token = localStorage.getItem("accessToken");

  if (!host || !token) {
    console.warn("Echo not initialized: missing host or token");
    return;
  }

  const connectionState = window.Echo?.connector?.pusher?.connection?.state;
  if (connectionState === "connected" || connectionState === "connecting") {
    console.log("Echo already connected or connecting");
    return;
  }

  if (window.Echo) {
    console.log("Reconnecting Echo");
    window.Echo.connect();
    return;
  }

  console.log("ws");

  const echoConfig = {
    broadcaster: "pusher",
    key: window.__env?.VUE_APP_LARAVEL_PUSHER_APP_KEY,
    wsHost: window.__env?.VUE_APP_LARAVEL_PUSHER_HOST,
    wsPort: window.__env?.VUE_APP_LARAVEL_PUSHER_PORT,
    wssPort: window.__env?.VUE_APP_LARAVEL_PUSHER_PORT,
    cluster: window.__env?.VUE_APP_LARAVEL_PUSHER_APP_CLUSTER || "mt1",
    forceTLS: window.__env?.VUE_APP_LARAVEL_PUSHER_ENABLED_TLS ?? true,
    encrypted: window.__env?.VUE_APP_LARAVEL_PUSHER_ENABLED_TLS ?? true,
    enableStats: true,
    enabledTransports: ["ws"],
    authEndpoint: `${window.__env?.VUE_APP_BASE_URL}/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  };

  // Solo agregar wsPath si tiene un valor
  if (window.__env?.VUE_APP_LARAVEL_PUSHER_PATH) {
    echoConfig.wsPath = window.__env.VUE_APP_LARAVEL_PUSHER_PATH;
  }

  console.log(echoConfig)

  window.Echo = new Echo(echoConfig);

  const pusher = window.Echo.connector.pusher;

  pusher.connection.bind("connected", () => {
    console.log("SOCKET CONNECTED");
  });

  pusher.connection.bind("disconnected", () => {
    console.warn("SOCKET DISCONNECTED");
  });

  pusher.connection.bind("error", (error) => {
    console.error("SOCKET ERROR", error);
  });

  pusher.connection.bind("state_change", (states) => {
    console.log("SOCKET STATE", states.previous, "->", states.current);
  });
}

new Vue({
  router,
  store,
  i18n,
  beforeCreate() {
    this.$store.dispatch("user/setUserDataFromLocalStorage");
    this.$store.dispatch("psimConfig/initializeStore");
    i18n.locale = this.$store.getters["user/getPreferences"].lang || "en";
    this.$store.dispatch("i18n/setMessages", i18n, i18n.locale);
    localize(i18n.locale);
    // subscribe the user private channel
    // subscribeUserPrivateChannel();
  },
  mounted() {
    initEcho();

    window.addEventListener("focus", () => {
      if (window.Echo?.connector?.pusher?.connection?.state !== "connected") {
        initEcho();
      }
    });

    window.addEventListener("pageshow", () => {
      if (window.Echo?.connector?.pusher?.connection?.state !== "connected") {
        initEcho();
      }
    });

    document.addEventListener("visibilitychange", () => {
      if (
        document.visibilityState === "visible" &&
        window.Echo?.connector?.pusher?.connection?.state !== "connected"
      ) {
        initEcho();
      }
    });
  },
  render: (h) => h(App),
}).$mount("#app");
